<div class="question">
  <p [class]="{'required' : question.isRequired}" [innerHTML]="question.title"></p>
  <app-attachments
    [downloadOnly]="true" 
    [attachments]="question.attachments"
    [downloadRoute]="downloadRoute">
  </app-attachments>
  <div class="md-form" (click)="questionElement.focus()">
    <textarea #answer="ngModel"
              mdbInput
              mdbValidate
              #questionElement
              type="text"
              class="md-textarea md-textarea-auto form-control"
              [required]="question.isRequired"
              [(ngModel)]="question.answers[0].value"
              [ngClass]="{'is-invalid' : questionElement.invalid && (questionElement.dirty || questionElement.touched), 'is-valid' : questionElement.valid}"
              (ngModelChange)="questionAnswered()"
              autosize>{{question.answers[0].value}}</textarea>
    <label>Your answer</label>
    <mdb-error *ngIf="answer.invalid && (answer.dirty || answer.touched)">Answer is required.</mdb-error>
  </div>
</div>
